import { post } from './common';
const translate = (phrase) => {
    return post('/Services/TranslationService.asmx/Translate', {
        Phrase: phrase
    })
        .then((resp) => {
        return resp.json();
    })
        .then((json) => {
        return json.d;
    });
};
const batchTranslate = (payload) => {
    return post('/Services/TranslationService.asmx/batchTranslate', payload);
};
export { translate, batchTranslate };
